<template>
  <div>
    <h4 class="mb-3">Notificações automáticas</h4>
    <p class="text-muted">Personalize o texto e a exibição (pop-up) das notificações do sistema.</p>

    <table class="table table-borderless table-align">
      <thead>
        <tr>
          <th>Notificação</th>
          <th>Estado</th>
          <th>Exibição</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="t in templates" :key="t.key">
          <td>{{ t.label }}</td>
          <td>
            <span :class="t.enabled ? 'badge badge-primary' : 'badge badge-secondary'">
              {{ t.enabled ? 'Personalizado' : 'Padrão' }}
            </span>
          </td>
          <td>{{ displayType(t) === 'popup' ? 'Pop-up' : 'Sininho' }}</td>
          <td>
            <button class="btn btn-outline" @click="edit(t)">Editar</button>
          </td>
        </tr>
      </tbody>
    </table>

    <Modal v-model="showModal" v-if="current">
      <div slot="header">{{ current.label }}</div>

      <div class="form-group">
        <label>Variáveis (clique para inserir; * = obrigatória)</label>
        <div>
          <button v-for="v in current.variables" :key="v" class="btn btn-outline mr-1 mb-1"
                  @click="insertVar(v)">
            {{ chip(v) }}
          </button>
        </div>
      </div>

      <div class="form-group">
        <label>Título</label>
        <input v-model="current.title" class="form-control">
      </div>
      <div class="form-group">
        <label>Mensagem</label>
        <textarea v-model="current.content" class="form-control" rows="4"/>
      </div>

      <div class="form-group">
        <label>Exibição</label>
        <div>
          <label class="mr-3">
            <input type="radio" value="bell" v-model="current.detail.displayType" class="mr-1">Só sininho
          </label>
          <label>
            <input type="radio" value="popup" v-model="current.detail.displayType" class="mr-1">Pop-up
          </label>
        </div>
      </div>

      <template v-if="current.detail.displayType === 'popup'">
        <div class="form-group">
          <label>Animação</label>
          <select v-model="current.detail.animation" class="form-control">
            <option v-for="a in animationOptions" :value="a.value" :key="a.value">{{ a.label }}</option>
          </select>
        </div>
        <div class="row">
          <div class="col-md-6 form-group"><label>Cor de fundo</label>
            <input type="color" v-model="current.detail.bgColor" class="form-control"></div>
          <div class="col-md-6 form-group"><label>Cor de destaque</label>
            <input type="color" v-model="current.detail.accentColor" class="form-control"></div>
        </div>
        <div class="row">
          <div class="col-md-6 form-group"><label>Botão (texto)</label>
            <input v-model="current.detail.ctaText" class="form-control"></div>
          <div class="col-md-6 form-group"><label>Botão (link)</label>
            <input v-model="current.detail.ctaLink" class="form-control"></div>
        </div>
      </template>

      <div class="form-group" v-if="current.enabled">
        <span class="badge badge-primary">Personalização ativa</span>
        <small class="text-muted ml-2">Use "Restaurar padrão" para voltar ao texto padrão do sistema.</small>
      </div>

      <div class="form-group mt-3">
        <button v-if="current.enabled" @click="restore()" class="btn btn-outline btn-lg mr-2">Restaurar padrão</button>
        <button @click="showModal = false" class="btn btn-outline btn-lg mr-2">Cancelar</button>
        <button @click="save()" class="btn btn-primary btn-lg">Salvar</button>
      </div>
    </Modal>

    <Modal v-model="showErrors">
      <div slot="header">Variáveis faltando</div>
      <p>Não é possível salvar sem as variáveis obrigatórias. Corrija antes de continuar:</p>
      <ul>
        <li v-for="(e, i) in errors" :key="i">{{ e }}</li>
      </ul>
      <div class="form-group mt-3">
        <button @click="showErrors = false" class="btn btn-primary btn-lg">Entendi</button>
      </div>
    </Modal>
  </div>
</template>

<script>
  import Modal from '@/components/shares/specialTag/Modal'

  export default {
    name: 'NotificationTemplate',
    components: { Modal },
    data: () => ({
      templates: [],
      current: null,
      showModal: false,
      showErrors: false,
      errors: [],
      animationOptions: [
        { value: 'fade', label: 'Fade' },
        { value: 'slide-up', label: 'Slide (baixo)' },
        { value: 'slide-right', label: 'Slide (lado)' },
        { value: 'zoom', label: 'Zoom' },
        { value: 'bounce', label: 'Bounce' },
        { value: 'flip', label: 'Flip' }
      ]
    }),
    created() { this.load() },
    methods: {
      load() {
        this.axios.get('admin/notification_templates')
          .then((res) => { this.templates = (res && res.data) || [] })
          .catch(() => {})
      },
      displayType(t) { return (t.detail && (t.detail.displayType || t.detail.display_type)) || 'bell' },
      edit(t) {
        const detail = Object.assign({ displayType: 'bell' }, t.detail || {})
        this.current = { key: t.key, label: t.label, variables: t.variables || [], required: t.required || [],
                         title: t.title, content: t.content, enabled: t.enabled, detail }
        this.showModal = true
      },
      chip(v) { return '{{' + v + '}}' + (this.current.required.indexOf(v) !== -1 ? ' *' : '') },
      insertVar(v) { this.current.content = (this.current.content || '') + '{{' + v + '}}' },
      localMissing() {
        return (this.current.required || []).filter((v) => {
          return !new RegExp('\\{\\{\\s*' + v + '\\s*\\}\\}').test(this.current.content || '')
        })
      },
      save() {
        const miss = this.localMissing()
        if (miss.length) {
          this.errors = miss.map((v) => 'Faltando a variável obrigatória {{' + v + '}}')
          this.showErrors = true
          return
        }
        const c = this.current
        this.axios.put('admin/notification_templates/' + c.key, {
          title: c.title, content: c.content, detail: c.detail, enabled: true
        }).then(() => {
          this.$notify.add('Template salvo!')
          this.showModal = false
          this.load()
        }).catch((e) => {
          if (Array.isArray(e.errors) && e.errors.length) {
            this.errors = e.errors
            this.showErrors = true
          } else {
            this.$notify.add('Erro ao salvar template')
          }
        })
      },
      restore() {
        this.axios.delete('admin/notification_templates/' + this.current.key)
          .then(() => {
            this.$notify.add('Notificação restaurada para o padrão!')
            this.showModal = false
            this.load()
          })
          .catch(() => this.$notify.add('Erro ao restaurar'))
      }
    }
  }
</script>
